import { defineStore } from "pinia";
import { type Executor } from "@src/api";
import { normalize } from "@src/utils";

type ExecutorListState = {
  ids: string[];
  map: Record<string, Executor>;
};

const stateDefault: ExecutorListState = {
  ids: [],
  map: {},
};

export const useExecutorListStore = defineStore("executor_list", {
  state: () => stateDefault,
  actions: {
    add(executorList: Executor[]) {
      const normalized = normalize<Executor, "user_id">(executorList, "user_id");

      this.map = { ...this.map, ...normalized.map };
      this.ids = normalized.ids;
    },
    has(userId: string) {
      return this.map[userId] !== undefined;
    },
  },
});
